import React, { Component } from 'react'
import { Input, Alert, Button, Icon, Select } from 'antd'
import { inject, observer } from 'mobx-react'

import { parameters } from '@services/api'

import { parameterTypes } from '@texts/parameter'
import { serverError } from '../UserPopup/styles.scss'

@inject((store: any) => {
    const { paramGroupsStore } = store
    return { paramGroupsStore }
})
@observer
export default class ParametersPopup extends Component<any, any> {
    state: any = {
        values: {
            name: null,
            type: null,
            advantage: 0,
            speed_weight: 0,
            eco_weight: 0
        },
        visibility: false,
        deleteParameter: false,
        errors: {}
    }
    componentDidMount() {
        const { name, type, advantage, speed_weight, eco_weight } = this.props
        this.setState({ values: { name, type, advantage, speed_weight, eco_weight } })
    }
    toggleDelete = () => {
        this.setState(prevState => ({ deleteParameter: !prevState.deleteParameter }))
    }
    toggleParameter = () => {
        this.setState(prevState => ({ visibility: !prevState.visibility, errors: {}, deleteParameter: false }))
        this.handleCancelEdit()
    }
    handleSetValue = (field, value) => {
        this.setState(prevState => ({ values: { ...prevState.values, [field]: value } }))
    }
    handleSubmitParameter = async () => {
        const { name, type, param_group_id, advantage, speed_weight, eco_weight } = this.state.values
        const { id, right_param_set_id, rightUpdated } = this.props
        if (!type) {
            this.setState({ errors: { typeError: `עליך לבחור סוג הערך שיוזן לפרמטר` } })
        } else if (id) {
            await parameters
                .updateParameter({ name, type, param_group_id, id, advantage, speed_weight, eco_weight })
                .then(async res => {
                    await rightUpdated()
                    this.toggleParameter()
                })
                .catch(e => {
                    if (e.response.status === 404) {
                        this.setState({ errors: { serverError: `לא קיים פרמטר עם מזהה ${id}` } })
                    } else if (e.response.status === 400) {
                        this.setState({ errors: { serverError: 'פרמטר עם שם זה כבר קיים תחת טבלה זו' } })
                    } else if (e.response.status === 403) {
                        this.setState({
                            errors: {
                                serverError:
                                    'לא ניתן לשנות סוג של פרמטר שמוגדר בפוליסות תחת טבלה זו, עליך למחוק את הגדרות הפרמטר בפוליסות הרלוונטיות ורק אז יהיה ניתן לשנות את הסוג'
                            }
                        })
                    } else {
                        this.setState({ errors: { serverError: 'ישנה בעיה בהתחברות לשרת' } })
                    }
                })
        } else {
            await parameters
                .addParameter({ name, type, param_group_id, right_param_set_id })
                .then(async res => {
                    await rightUpdated()
                    this.toggleParameter()
                })
                .catch(e => {
                    if (e.response.status === 404) {
                        this.setState({ errors: { serverError: `לא קיימת טבלה עם מזהה ${right_param_set_id}` } })
                    } else if (e.response.status === 400) {
                        this.setState({ errors: { serverError: 'פרמטר עם שם זה כבר קיים תחת טבלה זו' } })
                    } else if (e.response.status === 403) {
                        this.setState({
                            errors: {
                                serverError:
                                    'לא ניתן לשנות סוג של פרמטר שמוגדר בפוליסות תחת טבלה זו, עליך למחוק את הגדרות הפרמטרים בפוליסות'
                            }
                        })
                    } else {
                        this.setState({ errors: { serverError: 'ישנה בעיה בהתחברות לשרת' } })
                    }
                })
        }
    }
    handleDeleteParameter = async () => {
        const { id, rightUpdated } = this.props
        if (id) {
            await parameters
                .deleteParameter(id)
                .then(async res => rightUpdated())
                .catch(e => {
                    if (e.response.status === 404) {
                        this.setState({ errors: { serverError: `לא נמצא פרמטר עם מזהה ${id}` } })
                    } else {
                        this.setState({ errors: { serverError: 'ישנה בעיה בהתחברות לשרת' } })
                    }
                })
        } else {
            this.setState({ errors: { serverError: `לא ניתן למחוק פרמטר ללא מזהה` } })
        }
    }
    handleCancelEdit = () => {
        const { name, type, param_group_id, advantage, speed_weight, eco_weight } = this.props
        this.setState({
            values: { name, type, param_group_id, advantage, speed_weight, eco_weight },
            errors: {},
            deleteParameter: false
        })
    }
    checkChanges = () => {
        const { values } = this.state
        return (
            (values.name === this.props.name || values.name === '') &&
            (values.type === this.props.type || values.type === '')
        )
    }
    render() {
        const { id } = this.props
        const { visibility, errors, deleteParameter, values } = this.state
        const { updated_by, paramGroupsStore } = this.props
        return (
            <div
                style={{
                    padding: '0.7rem 0',
                    borderBottom: '1px solid #e2e2e2',
                    backgroundColor: `${visibility ? '#e2e2e2' : 'initial'}`
                }}
            >
                <div onClick={() => this.toggleParameter()} style={{ cursor: 'pointer', padding: '0 0.5rem 0 1rem' }}>
                    <strong>
                        {id ? (
                            <span>
                                <span style={{ marginLeft: '0.5rem' }}>
                                    {visibility ? <Icon type="down" /> : <Icon type="left" />}
                                </span>
                                {this.props.name}
                                <span style={{ float: 'left', fontWeight: 'normal' }}>{updated_by}</span>
                            </span>
                        ) : (
                            <Button type="primary">
                                <Icon type="plus" /> הוספת פרמטר
                            </Button>
                        )}
                    </strong>
                </div>
                {'serverError' in errors ? (
                    <div style={{ padding: '0.5rem 1rem' }}>
                        <Alert type="error" message={errors.serverError} />
                    </div>
                ) : (
                    ''
                )}
                {!!visibility && (
                    <div style={{ marginTop: '0.5rem', padding: '0 1rem' }}>
                        <Select
                            id="parameter_type"
                            value={values.type}
                            style={{ width: '100%' }}
                            placeholder="בחר את סוג הערך שהיוזן לפרמטר"
                            onChange={e => this.handleSetValue('type', e)}
                        >
                            <Select.Option value="FLOAT">{parameterTypes['FLOAT']}</Select.Option>
                            <Select.Option value="BOOLEAN">{parameterTypes['BOOLEAN']}</Select.Option>
                            <Select.Option value="STRING">{parameterTypes['STRING']}</Select.Option>
                        </Select>
                        {'typeError' in errors ? <Alert type="error" message={errors.typeError} /> : ''}
                        <Select
                            onChange={e => this.handleSetValue('param_group_id', e)}
                            value={values.param_group_id}
                            style={{ width: '100%' }}
                            placeholder="ללא שיוך לקבוצה"
                        >
                            <Select.Option value={null} key="NOGROUP">
                                ללא שיוך לקבוצה
                            </Select.Option>
                            {paramGroupsStore.list.map(paramGroup => (
                                <Select.Option value={paramGroup.id} key={paramGroup.id}>
                                    {paramGroup.name}
                                </Select.Option>
                            ))}
                        </Select>
                        {values.type !== 'STRING' && (
                            <Select
                                onChange={e => this.handleSetValue('advantage', e)}
                                value={values.advantage}
                                style={{ width: '100%' }}
                                placeholder="עדיף שיהיה"
                            >
                                <Select.Option value={0}>
                                    {values.type === 'FLOAT' ? 'ככל שהמספר יותר קטן זה יותר טוב' : 'עדיף שיהיה לא'}
                                </Select.Option>
                                <Select.Option value={1}>
                                    {values.type === 'FLOAT' ? 'ככל שהמספר יותר גדול זה יותר טוב' : 'עדיף שיהיה כן'}
                                </Select.Option>
                            </Select>
                        )}
                        <Input
                            autoComplete="off"
                            placeholder="משקל בחישוב של מי יותר משתלם בין 0 ל100"
                            value={values.eco_weight}
                            onChange={e => this.handleSetValue('eco_weight', e.target.value)}
                        />
                        <Input
                            autoComplete="off"
                            placeholder="משקל בחישוב של מי יותר מהיר בין 0 ל100"
                            value={values.speed_weight}
                            onChange={e => this.handleSetValue('speed_weight', e.target.value)}
                        />
                        <Input
                            autoComplete="off"
                            placeholder="הזן את שם הפרמטר"
                            name="name"
                            value={values.name}
                            onChange={e => this.handleSetValue('name', e.target.value)}
                        />
                        {!!deleteParameter && (
                            <div
                                style={{
                                    background: '#9c2222',
                                    padding: '0.5rem',
                                    marginBottom: '0.4rem',
                                    color: 'white',
                                    textAlign: 'center'
                                }}
                            >
                                <span>
                                    <strong style={{ fontSize: '1.2rem' }}>אזהרה!</strong> מחיקת פרמטר זה תגרור
                                    <strong>מחיקה של כל ההגדרות</strong> הרלוונטיות לפרמטר זה בכל הפוליסות המקושרות
                                    אליו, האם בכל זאת למחוק פרמטר זה?
                                </span>
                                <br />
                                <a
                                    style={{ fontWeight: 'bold', textDecoration: 'underline' }}
                                    onClick={() => this.toggleDelete()}
                                >
                                    בטל מחיקה
                                </a>
                                |
                                <a
                                    onClick={() => this.handleDeleteParameter()}
                                    style={{ fontWeight: 'bold', textDecoration: 'underline' }}
                                >
                                    מחק פרמטר
                                </a>
                            </div>
                        )}
                        <Button
                            type="primary"
                            disabled={
                                (values.name === this.props.name || values.name === '') &&
                                (values.type === this.props.type || values.type === '') &&
                                values.param_group_id === this.props.param_group_id &&
                                (values.advantage === this.props.advantage || values.advantage === '') &&
                                (values.speed_weight === this.props.speed_weight || values.speed_weight === '') &&
                                (values.eco_weight === this.props.eco_weight || values.eco_weight === '')
                            }
                            onClick={() => this.handleSubmitParameter()}
                        >
                            {id ? (
                                <span>
                                    <Icon type="check" /> שמור שינויים
                                </span>
                            ) : (
                                'הוסף פרמטר'
                            )}
                        </Button>
                        {!!(
                            (values.name !== this.props.name && values.name !== '') ||
                            (values.type !== this.props.type && values.type !== '') ||
                            values.param_group_id !== this.props.param_group_id ||
                            (values.advantage !== this.props.advantage && values.advantage !== '') ||
                            (values.speed_weight !== this.props.speed_weight && values.speed_weight !== '') ||
                            (values.eco_weight !== this.props.eco_weight && values.eco_weight !== '')
                        ) && (
                            <Button onClick={() => this.handleCancelEdit()}>
                                <Icon type="stop" /> ביטול
                            </Button>
                        )}
                        {!!(id && !deleteParameter) && (
                            <span style={{ float: 'left' }}>
                                <Button style={{ marginLeft: '0' }} onClick={() => this.toggleDelete()}>
                                    <Icon type="delete" /> מחק פרמטר
                                </Button>
                            </span>
                        )}
                    </div>
                )}
            </div>
        )
    }
}
